var _module_exports ="<!-- Full - Control -->\n<div grc-control\n     box-tmpl=\"full\"\n     box-model=\"control\"></div>";;
var path = '/app/Main/grcEdit/control/controlAdd.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;